/*
 * @Author: Gsan
 * @Date: 2019-12-01 02:04:24
 * @Last Modified by: Gsan
 * @Last Modified time: 2020-05-15 16:08:35
 */

/**
 * 时间戳格式转换
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * 格式化时间
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * 图片url转换成base64
 * @param {*} url 图片地址
 */
export function loadBase64Img(url) {
  return new Promise(resolve => {
    let img = new Image()
    img.crossOrigin = 'Anonymous'
    img.src = url
    img.onload = function () {
      resolve(getBase64Image(img))
    }
    // img.setAttribute('crossOrigin', 'anonymous')
  })
}

/**
 * 图片预加载
 * @param {*} url
 * @param {*} crossOrigin
 */
export function loadImg(url, crossOrigin = false) {
  return new Promise(resolve => {
    let img = new Image()
    img.onload = function () {
      resolve(img)
    }
    img.src = url
    if (crossOrigin) {
      img.setAttribute('crossOrigin', 'anonymous')
    }
  })
}

export function getBase64Image(img) {
  let canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  let ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height) // 绘制相同图片
  return canvas.toDataURL('image/png') // 转换成base64数据
}


/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"')
    .replace(/\+/g, ' ') +
    '"}'
  )
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export default function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

/* 字符串转Unicode十六进制 */
function strToUnicode(str) {
  var result = ""
  for (var i = 0; i < str.length; i++) {
    var code = str.codePointAt(i).toString(16)
    result += `\\u\{${code}\}`
    if (code.length > 4) {
      i++; // 由于str.length也只能处理两个字节的文字，所以这里需要判断如果codePointAt得到多字符就得跳过一次循环
    }
  }
  return result
}
/* 通过文字二进制得到文字字节数 */
function getByteByBinary(binaryCode) {
  /**
   * 二进制 Binary system,es6表示时以0b开头
   * 八进制 Octal number system,es5表示时以0开头,es6表示时以0o开头
   * 十进制 Decimal system
   * 十六进制 Hexadecimal,es5、es6表示时以0x开头
   */
  var byteLengthDatas = [0, 1, 2, 3, 4]
  var len = byteLengthDatas[Math.ceil(binaryCode.length / 8)]
  return len
}
/* 通过文字十六进制得到文字字节数 */
function getByteByHex(hexCode) {
  return getByteByBinary(parseInt(hexCode, 16).toString(2))
}
/* 截取指定字符数长度的文本 如果后一个字符截取后超出指定的长度，将不会截取该字符 */
export function substringByByte2(str, maxLength, overStr = '') {
  var data = strToUnicode(str)
  var reg = new RegExp(
    /\\u\{[A-z0-9]+\}(\\u\{200d\}{1}\\u\{[A-z0-9]+\})*/,
    "g"
  ); // 使用正则表达式分割每个完整字符
  var datas = reg[Symbol.match](data)
  var result = ""
  var length = 0
  for (var i in datas) {
    var value = datas[i].split("\\u").slice(1)
    // var len = 0
    value = value.map(str => {
      var value = str
        .replace(/\\u/g, "")
        .replace(/{/g, "")
        .replace(/}/g, "")
      length += getByteByHex(value)
      return parseInt(value, 16)
    })
    if (length <= maxLength) {
      result += String.fromCodePoint(...value)
    } else {
      result += overStr
      break
    }
  }
  return result
}

export function lengthByByte2(str) {
  var data = strToUnicode(str)
  var reg = new RegExp(
    /\\u\{[A-z0-9]+\}(\\u\{200d\}{1}\\u\{[A-z0-9]+\})*/,
    "g"
  ); // 使用正则表达式分割每个完整字符
  var datas = reg[Symbol.match](data)
  var result = ""
  var length = 0
  for (var i in datas) {
    var value = datas[i].split("\\u").slice(1)
    // var len = 0
    value = value.map(str => {
      var value = str
        .replace(/\\u/g, "")
        .replace(/{/g, "")
        .replace(/}/g, "")
      length += getByteByHex(value)
      return parseInt(value, 16)
    })
  }
  return length
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}
